"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TagWithParent = void 0;
const Tag_1 = require("../models/Tag");
class TagWithParent extends Tag_1.Tag {
    parent;
}
exports.TagWithParent = TagWithParent;
//# sourceMappingURL=TagWithParent.js.map